module.exports = __webpack_public_path__ + "static/media/map-location-active.699f5949.svg";